module.exports = __webpack_public_path__ + "img/navigation-menu-sumitomolife.edc23827.svg";